import React, { useEffect, useState } from 'react'
import RejectionChartWithoutControls from '../../components/RejectionDoughnut/RejectionChartWithoutControls'
import { showNotification } from '../../utils/toast.utils'
import * as dashboardService from '../../service/dashboard.service'
import StyledSelectField from '../../components/StyledSelectField/StyledSelectField'

const RejectionWrapperMachineWise = ({
  selectedDate,
  machine,
  selectedShift
}) => {
  const defaultPartFamily = {
    value: 'all',
    label: 'All part operations'
  }

  const [isLoading, setIsLoading] = useState(false)
  const [rejectionData, setRejectionData] = useState({})
  const [selectedPartFamily, setSelectedPartFamily] =
    useState(defaultPartFamily)
  const [availablePartFamilyShiftWise, setAvailablePartFamilyShiftWise] =
    useState({})

  useEffect(() => {
    setSelectedPartFamily(defaultPartFamily)
  }, [machine])

  useEffect(() => {
    setSelectedPartFamily(defaultPartFamily)
  }, [selectedShift])

  useEffect(() => {
    const fetchData = async () => {
      const params = {}
      if (selectedDate) params.date = selectedDate

      try {
        setIsLoading(true)
        const response = await dashboardService.getRejectionDataForDay(params)

        if (response.data.success) {
          const rejectionData =
            response.data.data.rejectionMachineWiseData || {}
          setRejectionData(rejectionData)

          const partFamilyOptions = { S1: [], S2: [], S3: [], day: [] }

          const machinesToProcess =
            machine && machine.value && machine.value !== 'overall'
              ? [machine.value]
              : Object.keys(rejectionData)

          machinesToProcess.forEach((machineName) => {
            const machineObj = rejectionData[machineName]
            if (!machineObj) return

            Object.keys(machineObj).forEach((shift) => {
              if (!partFamilyOptions[shift]) partFamilyOptions[shift] = []

              Object.keys(machineObj[shift]).forEach((partType) => {
                if (!partFamilyOptions[shift].includes(partType)) {
                  partFamilyOptions[shift].push(partType)
                }
                if (!partFamilyOptions.day.includes(partType)) {
                  partFamilyOptions.day.push(partType)
                }
              })
            })
          })

          setAvailablePartFamilyShiftWise(partFamilyOptions)
          setSelectedPartFamily(defaultPartFamily)
        } else {
          showNotification(response.data.message, 'error')
        }
      } catch (error) {
        console.error('Error fetching rejection data:', error)
        showNotification('Failed to fetch rejection data', 'error')
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [selectedDate, machine])

  if (isLoading) return <>Loading...</>

  let machineData = {}

  if (!machine || machine.value === 'overall') {
    machineData = rejectionData['overall'] || {}
  } else {
    machineData = rejectionData[machine.value] || {}
  }

  const shiftData =
    selectedShift && selectedShift.value && machineData[selectedShift.value]
      ? machineData[selectedShift.value]
      : {}

  const aggregateShiftData = (shiftData) => {
    const aggregatedData = {}

    Object.keys(shiftData).forEach((shift) => {
      Object.keys(shiftData[shift]).forEach((partFamily) => {
        if (!aggregatedData[partFamily]) aggregatedData[partFamily] = {}
        Object.keys(shiftData[shift][partFamily]).forEach((reason) => {
          if (!aggregatedData[partFamily][reason]) {
            aggregatedData[partFamily][reason] = 0
          }

          aggregatedData[partFamily][reason] +=
            shiftData[shift][partFamily][reason]
        })
      })
    })

    return aggregatedData
  }

  const combinedShiftData =
    selectedShift && selectedShift.value === 'all'
      ? aggregateShiftData(machineData)
      : shiftData

  const filteredShiftData =
    selectedPartFamily.value === 'all'
      ? combinedShiftData
      : combinedShiftData[selectedPartFamily.value]
        ? {
            [selectedPartFamily.value]:
              combinedShiftData[selectedPartFamily.value]
          }
        : {}

  const selectOptions =
    selectedShift && availablePartFamilyShiftWise[selectedShift.value]
      ? [
          defaultPartFamily,
          ...availablePartFamilyShiftWise[selectedShift.value].map((item) => ({
            label: item,
            value: item
          }))
        ]
      : [defaultPartFamily]

  const rejData =
    filteredShiftData &&
    Object.keys(filteredShiftData).length > 0 &&
    Object.values(filteredShiftData).some((reasonsObj) =>
      Object.values(reasonsObj).some((v) => Number(v) > 0)
    )

  return (
    <>
      {filteredShiftData && Object.keys(filteredShiftData).length > 0 ? (
        <RejectionChartWithoutControls
          rejectionData={filteredShiftData}
          selectionComponent={
            selectOptions.length > 1 && (
              <StyledSelectField
                label=""
                placeHolderText="Select part operations"
                selectedValue={selectedPartFamily}
                selectOptions={selectOptions}
                onChangeHandler={(value) => setSelectedPartFamily(value)}
                isMulti={false}
                isSearchable={true}
                isDisabled={false}
                noOptionsMessage="No part operation found"
              />
            )
          }
        />
      ) : (
        <>
          <p>No rejection data available for this selection.</p>
        </>
      )}
    </>
  )
}

export default RejectionWrapperMachineWise
